import { Slot, useGlobalSearchParams } from 'expo-router'
import type { ReactNode } from 'react'

import { Protected } from '../components/Protected'

export const ProtectedLayout = (): ReactNode => {
  const searchParams = useGlobalSearchParams()

  return (
    <Protected searchParams={searchParams}>
      <Slot />
    </Protected>
  )
}
